import { Col, Grid, Row, Skeleton } from "antd";
import { Fragment, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { NoData, Title } from "../../../../components";
import CustomRadioButton from "../../../../components/CustomRadioButton";
import { useLazyLoad } from "../../../../hooks/lazyLoad/lazyLoad.hooks";
import { NewsResponse } from "../../../../hooks/News/data";
import useGetTimezone from "../../../../hooks/Timezone/timezone.hooks";
import { ContentWrapper } from "../../../../layouts/components";
import { NewsContainerProps } from "../../data";
import NewsItem from "../NewsItem";
import styles from "./styleModule";

const NewsContainer = ({
  options,
  selectedCategory,
  onChange,
  loadingCategory,
  news,
  handleOpenDetail,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  loadingNews,
}: // currentPage,
// onPageChange,
// handlePrevPage,
// handleNextPage,
// totalPages,
NewsContainerProps) => {
  const { t } = useTranslation();
  const observer = useRef<HTMLDivElement>(null);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { toLocalTimezone, formatSmartDate } = useGetTimezone();

  const lazyLoad = useLazyLoad({
    triggerRef: observer as React.RefObject<HTMLElement>,
    hasNextPage: hasNextPage,
    fetchNextPage: fetchNextPage,
    isFetching: isFetchingNextPage,
  });
  const skeletonHeight = 240;
  const renderSkeleton = () => {
    return (
      <div className={styles.skeletonContainer}>
        <Row style={{ width: "100%" }} gutter={screens.sm ? [22, 22] : [0, 22]}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Col
              key={i}
              span={screens.xl ? 6 : screens.sm ? 8 : 24}
              style={{ height: skeletonHeight }}
            >
              <div
                className={styles.skeletonItem}
                style={{ height: skeletonHeight }}
              >
                <Skeleton.Node
                  active
                  style={{ width: "100%", height: skeletonHeight }}
                />
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  };
  const renderItems = () => {
    if (loadingNews) {
      return renderSkeleton();
    }
    if (!news || !news?.pages || (news?.pages[0] as any).data?.length <= 0) {
      return (
        <NoData
          title={t("news.nodata.title")}
          subtitle={t("news.nodata.subtitle")}
          offsetTop={80}
        />
      );
    }
    return (
      <div className={styles.newsContainer}>
        <Row style={{ width: "100%" }} gutter={screens.sm ? [22, 22] : [0, 22]}>
          {news?.pages?.map((group: any, index: number) => {
            console.debug("group", group);
            const _news: NewsResponse[] = group.article_list;
            return (
              <Fragment key={index}>
                {_news?.map((article: NewsResponse, index: number) => (
                  <NewsItem
                    key={index}
                    article={article}
                    handleOpenDetail={handleOpenDetail}
                  />
                ))}
              </Fragment>
            );
          })}
        </Row>
      </div>
    );
  };
  useEffect(() => {
    console.debug("news", news);
  }, [news]);
  return (
    <ContentWrapper>
      <Title
        title={t("news.title")}
        subtitle={t("news.subtitle")}
        needHome={true}
      />
      <CustomRadioButton
        items={options}
        selectedValue={selectedCategory}
        onValueChange={onChange}
        loading={loadingCategory}
      />
      {renderItems()}
      {hasNextPage && (
        <div ref={observer} style={{ display: hasNextPage ? "flex" : "none" }}>
          {isFetchingNextPage && renderSkeleton()}
        </div>
      )}
    </ContentWrapper>
  );
};

export default NewsContainer;
